import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isEmpty, uniq } from 'lodash';
import ProductCardList from './ProductCardList';
import { useProductInformationState } from '../Provider';
import * as action from '../../store/DevelopmentOrder.action';
import ProductFilter from '../ProductFilter';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';

function ReorderList() {
  const { state, setState, callGetDevorderListApi } = useProductInformationState();
  const { Measuremets } = useSelector((reducerState) => reducerState);
  const { reOrderList } = Measuremets;
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { filterData, filterSort, productFilterData, activeList, searchText, isSelectAll, selectedIds } = state;

  const handleApplyFilter = async (filterObj) => {
    setState((prevData) => ({
      ...prevData,
      filterData: filterObj,
      pageIndex: 0,
      pageLoading: true,
    }));
    const object = {
      archived: activeList !== 'open',
      deleted: activeList === 'bin',
      devOrderId: state?.LinkId,
      searchText,
      count: 0,
      ...filterObj,
      ...filterSort,
    };
    if (state?.selectedGroupId) {
      object.groupId = state?.selectedGroupId;
    }
    dispatch(action.getReorderList(object));
  };

  const handleSearchText = (text) => {
    setState((prevData) => ({
      ...prevData,
      searchText: text,
    }));
  };

  useEffect(() => {
    if (!isEmpty(reOrderList)) {
      setState((prevState) => ({
        ...prevState,
        productFilterData: reOrderList.reOrders,
      }));
    }
  }, [reOrderList]);

  const submitSearch = async (e) => {
    if (e.keyCode === 13) {
      setState((prevData) => ({
        ...prevData,
      }));
      await dispatch(
        action.getReorderList({
          archived: activeList !== 'open',
          deleted: activeList === 'bin',
          devOrderId: state?.LinkId,
          count: 0,
          searchText,
          ...filterData,
          ...filterSort,
        }),
      );
    }
  };

  const goBackToListing = async () => {
    const localstorageFilter = JSON.parse(localStorage?.getItem('productListFilter'));
    const listApiObj = { archived: state?.activeList !== 'open', searchText: state?.searchText, count: 0, ...localstorageFilter, ...state?.filterSort };
    await callGetDevorderListApi(listApiObj);
    setState((prevData) => ({
      ...prevData,
      isLinkOpen: false,
      isSelectAll: false,
      LinkId: '',
    }));
  };

  useEffect(() => {
    if (state?.selectedIds?.length > 0) {
      const idsToCheck = productFilterData?.map((ele) => {
        return ele._id;
      });
      setState((prevData) => ({
        ...prevData,
        isSelectAll: idsToCheck?.every((id) => state?.selectedIds.includes(id)),
      }));
    }
  }, [state?.selectedIds]);

  const onSelectAll = () => {
    if (Array.isArray(productFilterData) && productFilterData?.length > 0 && !isSelectAll) {
      const ids = productFilterData?.map((ele) => {
        return ele._id;
      });
      setState((prevData) => ({
        ...prevData,
        isSelectAll: !isSelectAll,
        selectedIds: uniq([...(prevData?.selectedIds || []), ...ids]),
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        isSelectAll: !isSelectAll,
        selectedIds: [],
      }));
    }
  };
  const expandSearchRefCuster = useRef(null);
  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefCuster.current.classList.toggle('active-input');
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">
            {t('FILTER.PRODUCTS')}
            {' | Cluster - '}
            {reOrderList?.parentOrder}
          </h4>
        </div>
        <div className="search-filter">
          {selectedIds?.length > 0 && (
            <span className="d-none d-md-inline-block  f-16 text-medium text-black mr-16">
              {selectedIds?.length}
              {t('FILTER.PRODUCT_SELECTED')}
            </span>
          )}
          <div ref={expandSearchRefCuster} className="common-expand-search without-dropdown">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only">Search</span>
              <span className="icon-Magnifying-Glass-Solid" />
            </button>
            <input
              type="text"
              value={searchText}
              onChange={(e) => handleSearchText(e.target.value)}
              onKeyUp={(e) => submitSearch(e)}
              className="form-control"
              placeholder={t('FILTER.SEARCH_PRODUCTS')}
            />
          </div>
          <div className="action-icons-container">
            <ProductFilter applyFilter={handleApplyFilter} filterData={filterData} activeList={activeList} />
            <CustomTooltip tooltipText={t('DUPLICATE_DELETE_MODAL.CLOSE_BUTTON_LABEL')}>
              <button type="button" className="btn" aria-label={t('DUPLICATE_DELETE_MODAL.CLOSE_BUTTON_LABEL')} onClick={goBackToListing}>
                <span className="icon-close f-22" />
              </button>
            </CustomTooltip>
          </div>
        </div>
      </div>
      <Container fluid className="py-2">
        <Row>
          <Col md={12} className="mt-3 text-right">
            {activeList !== 'bin' && (
              // <button type="button" className="btn btn-default mb-2 mb-md-0" onClick={() => onSelectAll()}>
              //   {isSelectAll ? "Unselect" : "Select"} {t("FILTER.All")}
              // </button>
              <div className="common-checkbox bold d-inline-flex">
                <NewCheckbox
                  size="sm"
                  id="checkAllProductCluster"
                  checked={isSelectAll}
                  onClick={() => onSelectAll()}
                  label={<span>{t('TAKING_DATES.SELECT_ALL')}</span>}
                />
              </div>
            )}
          </Col>
          <Col md={12}>
            {productFilterData?.length > 0 ? (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1440: 4 }}>
                <Masonry className="custom-masonry" gutter="30px">
                  {productFilterData.map((ele, i) => (
                    <ProductCardList key={ele?._id} item={ele} index={i} isEditIconVisible={activeList === 'open'} />
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            ) : (
              <p className="text-center mt-4"> {t('FILTER.NO_PRODUCT_FOUND')}</p>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ReorderList;
